export function isOfflineEnabled() {
  const env = String(process.env.REACT_APP_OFFLINE || '').toLowerCase();
  if (env === '1' || env === 'true') return true;
  try {
    if (typeof globalThis.window !== 'undefined') {
      const v = String(localStorage.getItem('ss_offline') || '').toLowerCase();
      return v === '1' || v === 'true';
    }
  } catch {}
  return false;
}

export function setOfflineEnabled(enabled) {
  try {
    localStorage.setItem('ss_offline', enabled ? '1' : '0');
  } catch {}
}

// Backwards-compatible constant for modules that only need a snapshot.
export const IS_OFFLINE = isOfflineEnabled();
